export const DEPARTMENT_OPTIONS = ['Sales', 'Customer Support', 'Tours', 'Cruises', 'Flight Support'];

export interface CustomerContext {
  conversationRef?: string | null;
  agentId?: string | null;
  customerId?: string | null;
  customerName?: string | null;
  orderId?: string | null;
  department?: string | null;
  mode?: 'default' | 'fraud';
  page?: string | null;
}
